import { render, staticRenderFns } from "./Forgot-password.vue?vue&type=template&id=31b3ff44&scoped=true&"
import script from "./Forgot-password.vue?vue&type=script&lang=js&"
export * from "./Forgot-password.vue?vue&type=script&lang=js&"
import style0 from "./Forgot-password.vue?vue&type=style&index=0&id=31b3ff44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b3ff44",
  null
  
)

export default component.exports